import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import Icon from 'components/core/Icon/Icon'
import classNames from 'lib/util/classNames'
import BorderHighlight from '../BorderHighlight/BorderHighlight'
import styles from './NotifySymbol.module.scss'

/**
 * The `NotifySymbol` component
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function NotifySymbol (props) {
  const { className, color, icon } = props
  const classNameOutput = useMemo(
    () => classNames([className, styles.check, styles[`color-${color}`]]),
    [className, color]
  )

  return (
    <div className={classNameOutput}>
      <Icon icon={icon} />
      <BorderHighlight className={styles.highlight} isActive={true} />
    </div>
  )
}

/** @type {object} */
NotifySymbol.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  color: PropTypes.string
}

/** @type {object} */
NotifySymbol.defaultProps = {
  className: '',
  icon: 'check',
  color: ''
}

// Memoize
export default memo(NotifySymbol)
